import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAdmin } from "../../context/AdminContext.js";
import Spinner from "../../components/Spinner.js";

// This only controls what renders in the browser. The real authorization boundary is server-side —
// every admin API endpoint independently checks the session and rejects unauthenticated requests.
const ProtectedRoute = () => {
  const { admin, loading } = useAdmin();

  if (loading) {
    return (
      <div className="admin-loading">
        <Spinner label="Loading…" />
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
